// global promise on onYouTubeIframeAPIReady (script loading should only happen once)
const YTReady = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve(window.YT)
})

export default YTReady
